export default __webpack_public_path__ + "static/media/429.898d8518.gif";